export default {
  request: [
    (config) => {
      config.params = config.params || {}
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  ],
  response: [
    (response) => {
      return response.data
    },
    (error) => {
      return new Promise((_, reject) => {
        reject(error)
      })
    }
  ]
}
